import React from 'react'
import InfoCard from '../components/CardComponent'
import ServicesCard from '../components/CardComponent/ServicesCard'
import HeroSection2 from '../components/HeroSectionService'
import InfoSection from '../components/InfoSection2'

//images
import techRec_serv_img from '../images/technical-recruitment-is.png'

import { servicesHomeData } from './data'

const Services = () => {
  return (
    <>
      {servicesHomeData.map((shd) => {
        return <InfoSection {...shd}></InfoSection>
      })}
      {/* <ServicesCard></ServicesCard> */}
      {/* <HeroSection2></HeroSection2> */}
    </>
  )
}

export default Services
